import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AreasSeatService } from 'src/app/services/areas-seat.service';

@Component({
  selector: 'app-create-levels',
  templateUrl: './create-levels.component.html',
  styleUrls: ['./create-levels.component.scss']
})
export class CreateLevelsComponent implements OnInit {

  levels: any[] = [];
  idLevel: number = 1;
  originalColors: Map<any, string> = new Map();

  constructor(
    public dialogRef: MatDialogRef<CreateLevelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private areaSeatService: AreasSeatService
  ) { }

  ngOnInit(): void {
    // Agregar una sección por defecto
    if (this.data && this.data.levels?.length != 0) {
      this.data.levels?.forEach((level: any) => {
        // Los niveles que vienen de la API traen la prioridad en snake_case; sin
        // normalizarla el input de Prioridad sale vacío y confirmSections los ordena
        // todos como 0. Los mapas guardados sin prioridad se numeran por posición.
        level.orderBuy = level.orderBuy ?? level.order_buy ?? this.idLevel;
        this.levels.push(level);
        this.originalColors.set(level.id ?? level.orderBuy, level.color);
        this.idLevel++;
      });
    } else {
      this.addLevel();
    }
  }

  addLevel() {
    let color = this.areaSeatService.getIndexColor(this.idLevel - 1);
    let objLevel = {
      orderBuy: this.idLevel,
      name: 'Sección ' + this.idLevel,
      color: color,
      seats: 0,
      id: this.idLevel
    };
    this.levels.push(objLevel);
    this.originalColors.set(objLevel.id, color);
    this.idLevel++;
  }

  deleteLevel(level: any) {
    if (this.levels.length > 1) {
      const indexLevel = this.levels.indexOf(level);
      if (indexLevel !== -1) {
        this.levels.splice(indexLevel, 1);
      }
    }
  }

  updateLevelName(level: any, event: any) {
    level.name = event.target.value;
  }

  updateLevelColor(level: any, event: any) {
    level.color = event.target.value;
  }

  updateLevelOrderBuy(level: any, event: any) {
    const val = parseInt(event.target.value, 10);
    if (!isNaN(val) && val > 0) {
      level.orderBuy = val;
    }
  }

  isColorModified(level: any): boolean {
    const key = level.id ?? level.orderBuy;
    const original = this.originalColors.get(key);
    return original !== undefined && original !== level.color;
  }

  resetLevelColor(level: any) {
    const key = level.id ?? level.orderBuy;
    const original = this.originalColors.get(key);
    if (original) level.color = original;
  }

  confirmSections() {
    // Validar que todos los niveles tengan nombre
    const validLevels = this.levels.filter(level => level.name.trim() !== '');

    if (validLevels.length === 0) {
      alert('Debes crear al menos una sección');
      return;
    }

    const sortedLevels = [...validLevels].sort((a, b) => (a.orderBuy ?? 0) - (b.orderBuy ?? 0));

    localStorage.setItem('seatLevels', JSON.stringify(sortedLevels));

    this.dialogRef.close({
      confirmed: true,
      levels: sortedLevels
    });
  }

  skipSections() {
    this.dialogRef.close({
      confirmed: false,
      levels: []
    });
  }

  cancel() {
    this.dialogRef.close(this.data);
  }
}